import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  Inject,
  OnInit,
  OnDestroy,
  booleanAttribute,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppSettings } from 'src/app/config';
import { AuthenticationService } from 'src/app/services/apps/Authentication/authentication.service';
import { logoutToLogin } from 'src/app/services/apps/Authentication/logout-to-login';
import { NotificationsService, NotificationItem, NotificationKind, formatNotificationDescription } from 'src/app/services/notifications.service';
import { InvoicesService } from 'src/app/services/apps/invoices/invoices.service';
import { ManualInvoiceDialogComponent } from 'src/app/pages/apps/invoices/manual-invoice-dialog.component';
import { Subscription } from 'rxjs';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { JetsonStatusIndicatorComponent } from 'src/app/components/jetson-status-indicator/jetson-status-indicator.component';
import { AppSwitcherComponent } from 'src/app/layouts/full/shared/app-switcher/app-switcher.component';
import { AttentionGlobalSearchComponent } from 'src/app/layouts/attention/global-search/attention-global-search.component';
import { AudioService } from 'src/app/services/audio.service';
import { SignalRService } from 'src/app/services/signalr.service';
import { MatSnackBar } from '@angular/material/snack-bar';

// Removed old mock interface

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    TablerIconsModule,
    MaterialModule,
    NgScrollbarModule,
    JetsonStatusIndicatorComponent,
    AppSwitcherComponent,
    AttentionGlobalSearchComponent,
  ],
  templateUrl: './header.component.html',
  styles: [`
    .notification-badge {
      position: absolute;
      top: 0px;
      right: 0px;
      color: white;
      border-radius: 50%;
      padding: 0;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
      min-width: 18px;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      border: 2px solid white;
      z-index: 10;
    }
    a.tenant-header-empresa {
      cursor: pointer;
    }
    a.tenant-header-empresa:hover {
      text-decoration: underline;
      text-underline-offset: 3px;
    }
    .notifications-scroll {
      max-height: 400px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .notification-row {
      min-width: 0;
      gap: 8px;
    }
    .notification-body {
      min-width: 0;
      flex: 1 1 auto;
    }
    .notification-text {
      word-break: break-word;
      overflow-wrap: anywhere;
      line-height: 1.35;
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showToggle = true;
  /** Modo Atención (#192): buscador global de abonados en la barra superior. */
  @Input({ transform: booleanAttribute }) showGlobalSearch = false;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  isCollapse: boolean = false; // Initially hidden

  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }

  private updateUserDisplay(user: any | null): void {
    this.userData = user;
    this.displayName = this.authenticationService.getDisplayName(user);
  }

  showFiller = false;

  @Output() optionsChange = new EventEmitter<AppSettings>();

  userData: any = null;
  displayName = 'User';
  /** Nombre del estacionamiento (tenant) para contexto multi-tenant */
  tenantParkingName: string | null = null;
  private currentUserSubscription?: Subscription;
  private tenantNameSubscription?: Subscription;
  notifications: NotificationItem[] = [];
  private signalRSubscription?: Subscription;
  private parkingIncidentSubscription?: Subscription;

  // Exponer enum para usarlo en el template
  NotificationKind = NotificationKind;
  formatNotificationDescription = formatNotificationDescription;

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    private dialog: MatDialog,
    private router: Router,
    @Inject(AuthenticationService) private authenticationService: AuthenticationService,
    private notificationsService: NotificationsService,
    private invoicesService: InvoicesService,
    private audioService: AudioService,
    private signalRService: SignalRService,
    private snackBar: MatSnackBar
  ) {
    this.updateUserDisplay(this.authenticationService.getCurrentUserSnapshot());
    this.currentUserSubscription = this.authenticationService.currentUser$.subscribe(
      (user) => this.updateUserDisplay(user)
    );
    this.tenantNameSubscription = this.authenticationService.tenantDisplayName$.subscribe(
      (name) => (this.tenantParkingName = name)
    );
  }

  ngOnInit(): void {
    // Cargar notificaciones inmediatamente via HTTP
    this.loadNotifications();

    // Iniciar SignalR (idempotente - si ya está conectado, no hace nada)
    this.signalRService.start();

    // Escuchar nuevas notificaciones en tiempo real via SignalR
    this.signalRSubscription = this.signalRService.newNotification$.subscribe(
      (notification) => {
        console.log('[Header] New notification via SignalR:', notification);
        // Agregar al inicio de la lista
        this.notifications = [notification, ...this.notifications];
        // Reproducir sonido de notificación
        this.audioService.playNotification();
      }
    );

    this.parkingIncidentSubscription = this.signalRService.newParkingIncident$.subscribe((ev) => {
      const myId = this.authenticationService.getUserId();
      if (ev.operatorUserId && myId && ev.operatorUserId !== myId) {
        return;
      }
      const amount = typeof ev.estimatedAmount === 'number' ? ev.estimatedAmount.toFixed(2) : String(ev.estimatedAmount);
      this.snackBar.open(`Incidente de caja: placa ${ev.plate} — monto estimado $${amount}`, 'Cerrar', {
        duration: 14000,
        panelClass: ['mat-snack-bar-panel-incident']
      });
    });
  }

  ngOnDestroy(): void {
    // Limpiar subscriptions
    if (this.signalRSubscription) {
      this.signalRSubscription.unsubscribe();
    }
    if (this.parkingIncidentSubscription) {
      this.parkingIncidentSubscription.unsubscribe();
    }
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.tenantNameSubscription) {
      this.tenantNameSubscription.unsubscribe();
    }
  }

  loadNotifications(): void {
    this.notificationsService.getUnreadNotifications().subscribe({
      next: (response) => {
        console.log('[Notifications] Response received:', response);
        if (response.success && response.requestResult) {
          this.notifications = response.requestResult;
          console.log('[Notifications] Loaded count:', this.notifications.length);
          console.log('[Notifications] Notifications array:', this.notifications);
        } else {
          console.warn('[Notifications] No valid data in response');
          this.notifications = [];
        }
      },
      error: (error) => {
        console.error('[Notifications] Error loading notifications:', error);
        this.notifications = []; // Asegurar que esté vacío en caso de error
      }
    });
  }

  markNotificationAsRead(notificationId: string): void {
    this.notificationsService.markAsRead(notificationId).subscribe({
      next: (response) => {
        if (response.success) {
          // Recargar notificaciones después de marcar como leída
          this.loadNotifications();
        }
      },
      error: (error) => {
        console.error('Error marking notification as read:', error);
      }
    });
  }

  markAllNotificationsAsRead(): void {
    this.notificationsService.markAllAsRead().subscribe({
      next: (response) => {
        if (response.success) {
          this.loadNotifications();
        }
      },
      error: (error) => {
        console.error('Error marking all notifications as read:', error);
      }
    });
  }

  isClickableNotification(notification: NotificationItem): boolean {
    return (notification.kind === NotificationKind.InvoiceGenerated && !!notification.externalId) ||
           notification.kind === NotificationKind.BillingPending;
  }

  onNotificationClick(notification: NotificationItem): void {
    if (notification.kind === NotificationKind.PassExpired) {
      this.markNotificationAsRead(notification.id);
      return;
    }

    // Notificación de facturación pendiente → navegar a billing-suggestions
    if (notification.kind === NotificationKind.BillingPending) {
      this.markNotificationAsRead(notification.id);
      this.router.navigate(['/apps/billing-suggestions']);
      return;
    }

    // Si es una notificación de factura generada, abrir el modal de factura
    if (notification.kind === 1 && notification.externalId) { // NotificationKind.InvoiceGenerated
      // Obtener los detalles de la factura
      this.invoicesService.getInvoiceById(notification.externalId).subscribe({
        next: (response) => {
          if (response.success && response.body) {
            const invoice = response.body;

            // Abrir el modal de factura en modo "view"
            const dialogRef = this.dialog.open(ManualInvoiceDialogComponent, {
              width: '900px',
              maxWidth: '95vw',
              maxHeight: '90vh',
              disableClose: true,
              panelClass: 'invoice-dialog',
              data: {
                mode: 'view',
                invoice: invoice,
                showCancelButton: invoice.type === 'Cash' && invoice.status === 'Paid',
                reverseMode: true
              }
            });

            // Marcar como leída al abrir el modal
            this.markNotificationAsRead(notification.id);
          }
        },
        error: (error) => {
          console.error('Error loading invoice:', error);
        }
      });
    }
  }

  trackByNotificationId(index: number, notification: NotificationItem): string {
    return notification.id;
  }

  options = this.settings.getOptions();

  openDialog() {
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }
  onLogout(): void {
    logoutToLogin(this.authenticationService, this.router);
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  /** Admin del tenant puede abrir Mi organización; operadores y superadmin no (misma regla que el menú). */
  get canNavigateToTenantOrganization(): boolean {
    return this.authenticationService.isTenantAdministrator(
      this.authenticationService.getCurrentUserSnapshot()
    );
  }
}
